import script from "./ZNotFound.vue?vue&type=script&setup=true&lang=js"
export * from "./ZNotFound.vue?vue&type=script&setup=true&lang=js"

import "./ZNotFound.vue?vue&type=style&index=0&id=22ae705c&lang=scss"

const __exports__ = script;

export default __exports__